// Nick Fraser · Collector Editions — content constants & helpers
export const STORE_URL = "https://www.nickfraserartist.com/category/all-products";
export const CHAPTER_II_URL = "https://chapter2.nickfraserartist.com";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) {
      sessionStorage.setItem("the190_utm", JSON.stringify(utm));
    }
  } catch {
    /* no-op */
  }
}

export function storeUrl(content, base) {
  const url = new URL(base || STORE_URL);
  let utm = {};
  try {
    utm = JSON.parse(sessionStorage.getItem("the190_utm") || "{}");
  } catch {
    utm = {};
  }
  url.searchParams.set("utm_source", utm.utm_source || "collector-editions");
  url.searchParams.set("utm_medium", utm.utm_medium || "website");
  url.searchParams.set("utm_campaign", utm.utm_campaign || "collector-editions");
  if (utm.utm_term) url.searchParams.set("utm_term", utm.utm_term);
  url.searchParams.set("utm_content", content || utm.utm_content || "cta");
  return url.toString();
}

export const VIDEO_ID = "541kyL0zJDs";

// Editorial "Collector Story" — the "Artwork with a Continuing Story" section
export const COLLECTOR_STORY = [
  "Nick Fraser created an extraordinary body of work largely outside the traditional art establishment.",
  "Today, his archive is being preserved, documented and brought to new audiences through exhibitions, film, research and publication.",
  "The Collector Editions offer an opportunity to own a carefully produced edition of selected works from the archive — while directly contributing to that continuing story.",
];

// Retained biography for the artist panel
export const WHO_WAS_NICK = [
  "Nick Fraser was an East London artist whose remarkable creative life existed almost entirely outside the established art world.",
  "Born in Stratford, he spent more than three decades working at Tate & Lyle. Away from work, he quietly created hundreds of paintings and drawings over many years.",
  "His work explored spirituality, mythology, masculinity, identity, ritual and the human condition.",
  "He was self-taught. He worked with the materials available to him. He did not build a conventional art career, and much of the work remained unseen during his lifetime.",
  "Since his death, that story has slowly begun to come into the light.",
];

// The four provenance pillars — "CREATED FROM THE ARCHIVE"
export const PILLARS = [
  {
    title: "Limited",
    body: "Each work is produced as a strictly limited edition of 100.",
  },
  {
    title: "Signed & Numbered",
    body: "Each edition is individually signed and numbered.",
  },
  {
    title: "Authenticated",
    body: "Every edition is accompanied by a Certificate of Authenticity from the Nick Fraser Archive.",
  },
  {
    title: "Supporting the Archive",
    body: "Proceeds contribute directly to the preservation, documentation, exhibition and continued public life of Nick Fraser's work.",
  },
];

// What each collector receives — "YOUR EDITION"
export const YOUR_EDITION = [
  "One A3 archival giclée edition",
  "Signed and individually numbered",
  "Certificate of Authenticity",
  "Carefully packaged for delivery",
];

export function buildFaq(data) {
  return [
    { q: "Are the editions signed?", a: "Yes. Each edition is signed by the estate." },
    { q: "Are they numbered?", a: "Yes. Each edition is individually numbered within its edition of 100." },
    { q: "Do they include a certificate?", a: "Yes. Each edition is supplied with a Certificate of Authenticity from the Nick Fraser Archive." },
    { q: "What is the edition size?", a: "Each artwork is produced as a strictly limited edition of 100." },
    { q: "How much are they?", a: `Individual editions are ${data?.price_single || "£199"}.` },
    { q: "Can I collect both?", a: `Yes. The Collector Pair is available for ${data?.price_pair || "£350"} — a saving on collecting individually.` },
    { q: "Where do I purchase?", a: "All purchases are completed through the official Nick Fraser store, with each edition linking directly to its own product page.", link: true },
    { q: "What does my purchase support?", a: "Income from the editions contributes towards the continued preservation, research, documentation, film development and public presentation of the Nick Fraser Archive." },
    { q: "How are editions delivered?", a: data?.delivery_info || "Each edition is carefully prepared by the estate and packaged for safe delivery. Please contact us with any questions before purchasing." },
    { q: "Can I contact you before purchasing?", a: "Yes. We welcome questions before you collect.", contact: true },
  ];
}
